// import Glide from '@glidejs/glide';

export default () => {
    /*
    const slider = new Glide({
        container: '.carousel',
    }).mount();
    */
};
